import { createContext } from 'react';

interface AbTestContextProps {
  branch: string | null;
  trigger: PossibleTrigger;
  triggerFired: boolean;
  selector?: string;
  triggerCurrentTest: () => void;
  showShield?: boolean;
}

export enum PossibleTrigger {
  Load = 'load',
  Click = 'click',
  Delay = 'delay',
  Redirect = 'redirect',
  Submit = 'submit',
  Scroll = 'scroll',
  Visible = 'visible'
}

const defaultContext: AbTestContextProps = {
  branch: null,
  trigger: PossibleTrigger.Load,
  triggerFired: false,
  selector: undefined,
  triggerCurrentTest: () => undefined,
  showShield: false
};

export default createContext(defaultContext);
